import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { DialogBox } from './Styles/DeleteBucketDialogBox';

import { deleteBucket } from '../../../actions/inventoryActionsV2';

const DeleteBucketDialogBox = ({ open, bucket, onTrue, onFalse, ...props }) => {
	const onTrueHandler = async () => {
		await props.deleteBucket(bucket);
		onTrue();
	};

	const onFalseHandler = () => {
		onFalse();
	};

	useEffect(() => {}, [open, bucket]);

	return (
		<DialogBox
			open={open}
			title={'Delete Bucket'}
			content={'Are you sure you want to delete this bucket?'}
			onTrue={() => {
				onTrueHandler();
			}}
			onFalse={() => {
				onFalseHandler();
			}}
		/>
	);
};

const mapStatesToProps = (state) => {
	return {
		supplier: state.supplier.supplier,
	};
};

const mapFunctionsToProps = {
	deleteBucket,
};

export default connect(mapStatesToProps, mapFunctionsToProps)(DeleteBucketDialogBox);
